module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u_Feature-Testimonial_Kimberly-Ong-af232d477eae4d47741bad4bd9950927.jpg";